import _ from 'lodash';
import moment from 'moment';
import {
  createFetchActionForNamespace,
  createReducer,
  createFetchReducers,
  createFetchSelectors
} from 'utils/reducers';
import {getToday, formatDate} from 'utils/datetime';
import {buildBookingStateRevenueTableData} from './utils';

const createFetchAction = createFetchActionForNamespace('reporting/revenue');

export const fetchRevenueSummary = createFetchAction({
  name: 'FETCH_REVENUE_SUMMARY',
  initialAction: ({locationRef, resolution}) => ({
    payload: {locationRef, resolution}
  }),
  stateKey: 'summary',
  defaultStateValue: []
});

export const selectRevenueSummary = createFetchSelectors(fetchRevenueSummary)
  .data;

export const selectRevenueSummaryIsLoading = createFetchSelectors(
  fetchRevenueSummary
).isLoading;

export const fetchRevenueReport = createFetchAction({
  name: 'FETCH_REVENUE',
  initialAction: ({locationRef, resolution, periodStart, periodEnd}) => ({
    payload: {locationRef, resolution, periodStart, periodEnd}
  }),
  stateKey: 'overview',
  defaultStateValue: {
    bookingState: buildBookingStateRevenueTableData([]),
    maxPossibleRevenue: 0
  }
});
export const selectRevenueReport = createFetchSelectors(fetchRevenueReport)
  .data;
export const selectRevenueIsLoading = createFetchSelectors(fetchRevenueReport)
  .isLoading;

export const OVERVIEW_RESOLUTION_OPTIONS = {
  DAILY: {
    value: 'daily',
    label: 'Daily',
    defaultStartDate: getToday(),
    defaultEndDate: formatDate(moment().add(20, 'days'))
  },
  MONTHLY: {
    value: 'monthly',
    label: 'Monthly',
    defaultStartDate: getToday(),
    defaultEndDate: formatDate(moment().add(18, 'months'))
  },
  FINANCIAL_YEARS_MONTHLY: {
    value: 'monthly',
    label: 'Monthly (Financial year)',
    defaultStartDate: moment().format('01/04/YYYY'),
    defaultEndDate: moment()
      .add('1', 'years')
      .format('31/03/YYYY')
  },
  QUARTERLY: {
    value: 'quarterly',
    label: 'Quarterly',
    defaultStartDate: '01/01/2017',
    defaultEndDate: '31/12/2022'
  },
  CALENDAR_YEAR: {
    value: 'calendar_year',
    label: 'Calendar year',
    defaultStartDate: '01/01/2017',
    defaultEndDate: '31/12/2022'
  },
  FINANCIAL_YEAR: {
    value: 'financial_year',
    label: 'Financial year (Apr-Mar)',
    defaultStartDate: '01/04/2017',
    defaultEndDate: '31/03/2022'
  }
};

export const SUMMARY_RESOLUTION_OPTIONS = {
  CURRENT_MONTH: {
    value: 'current_month',
    label: 'Current Month'
  },
  CURRENT_QUARTER: {
    value: 'current_quarter',
    label: 'Current Quarter'
  },
  CURRENT_YEAR: {
    value: 'current_year',
    label: 'Current Year'
  },
  CURRENT_FINANCIAL_YEAR: {
    value: 'current_financial_year',
    label: 'Current Financial Year'
  },
  TOTAL_BOOKED: {
    value: 'total_booked',
    label: 'Total Booked'
  }
};

const fetchRevenueReportReducer = createFetchReducers(
  fetchRevenueReport,
  (state, action) => ({
    ...state,
    [action.parent.stateKey]: {
      isLoading: false,
      data: {
        maxPossibleRevenue: action.payload.maxPossibleRevenue,
        bookingState: buildBookingStateRevenueTableData(action.payload.data)
      }
    }
  })
);

const initialState = {};

const fetchReducers = createReducer(initialState, {
  ...createFetchReducers(fetchRevenueSummary),
  ...fetchRevenueReportReducer
});

const reducer = (state = {}, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;

export {default as revenueReportingSaga} from './saga';
